import { getLocale } from "../runtime";

const sv_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj ditt språk och land för att få den bästa shoppingupplevelsen.`
};

const chooseyourlanguageandcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_chooseyourlanguageandcountry(inputs)
	return "chooseYourLanguageAndCountry";
};

export { chooseyourlanguageandcountry as "chooseYourLanguageAndCountry" };